export default __webpack_public_path__ + "static/media/firstDance.89f616f1.jpg";